import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ExportLibraryMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ExportLibraryMutation = { __typename?: 'Mutation', exportLibraryContent: { __typename?: 'DoneResult', done: boolean } };


export const ExportLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportLibrary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportLibraryContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done"}}]}}]}}]} as unknown as DocumentNode<ExportLibraryMutation, ExportLibraryMutationVariables>;